import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { IMouseRelease, IMouseMove, IMouseDown, IDoubleClick } from '../Interfaces';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { Angle } from '../object3D';
import { SelectComponent } from '.';

@Injectable()
export class DrawAngleComponent extends ComponentBase
  implements IMouseMove, IMouseDown, IMouseRelease, IDoubleClick {
  added: boolean = false;
  dblclick(e: MouseEvent): boolean {

    this.angle = undefined;
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  }

  private firstPoint = null;
  private angle: Angle | undefined;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
  }

  mouseDown(e: MouseEvent): boolean {
    if (!this.firstPoint) {
      this.firstPoint = this.positionCalculator.calculate(e);
      this.angle = new Angle();
      this.angle.position.copy(this.firstPoint);
      return true;
    }
    return false;
  }

  mouseMove(e: MouseEvent): boolean {
    if (this.firstPoint) {
      const position = this.positionCalculator.calculate(e);
      if (this.firstPoint.distanceTo(position) > 4) {
        const endPoint = position
          .clone()
          .sub(this.firstPoint)
          .normalize()
          .multiplyScalar(150)
          .add(this.firstPoint);
        this.angle.update(this.firstPoint, endPoint);
        if (this.added) {
          
        } else {
          this.added = true;
          this.drawings.canvas.add(this.angle);
        }
      }
      return true;
    }
    return false;
  }

  mouseUp(): boolean {
    if (this.firstPoint) {
      this.firstPoint = null;
      this.added = false;
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawAngleComponent.ts